import "../CSS/itemAsientosPaulet.css";
import React, { useRef, useEffect, useState } from "react";
import Swal from "sweetalert2";

function ItemAsiento(props) {
  const { asiento, reserved,selected, onClick , isLocket} = props;

  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (!reserved) {
		onClick(asiento);
    }
  };
  const mystyle = {
	color: "white",
	backgroundColor: "DodgerBlue",
	padding: "10px",
	fontFamily: "Arial"
  };
  const seatStyle = {
    backgroundColor: reserved ? ' #ffb3b3' : selected ? '#acd9b2' : isHovered ? '#4490c4' : '#eee', 
	borderColor: reserved ? ' #ffb3b3' :selected ? '#acd9b2': isHovered ? '#4490c4' : '#acd9b2' ,

	fontSize: isHovered ? '12px' : '0px',
	cursor: reserved ? 'not-allowed' : selected ? 'default' : isHovered ? 'default' : isLocket ? 'not-allowed': '#eee', 
  };
  return (
    <div className="item-panel">
      <div
        className="asiento"
		onClick={handleClick}
		onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
        style={seatStyle}
      >
		{asiento}
	  </div>
    </div>
  );
/*
  return (
    <div className="item-panel">
      <div
        className={`seat ${selected ? "selected" : ""}`}
        onClick={() => onClick(id)}
      >
        {id}
      </div>
    </div>
  );*/
}

export default ItemAsiento;
